function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("linearGradient", {
  id: "gradient",
  x1: "0%",
  x2: "100%",
  y1: "99.907%",
  y2: "5.237%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#672D89"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#9C2463"
}));
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#72246C",
  opacity: 0.201,
  transform: "translate(-44 -266) translate(20 232) translate(24 33.195) translate(0 .805) translate(0 .833)",
  d: "M20.81 46.307C10.994 46.919-.35 36.902.008 24.782.307 14.66 7.788 3.119 22.443 3c9.43-.076 20.91 8.824 20.89 22.811-.013 9.143-8.603 21.104-22.523 20.496"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#gradient)",
  fillRule: "nonzero",
  transform: "translate(-44 -266) translate(20 232) translate(24 33.195) translate(0 .805) translate(0 .833) translate(13 .167)",
  d: "M5.412 1.496H7.6v-.46C7.6.46 8.06 0 8.636 0c.576 0 1.037.46 1.037 1.035v.46h11.4v-.46c0-.575.46-1.035 1.036-1.035.576 0 1.036.46 1.036 1.035v.46H26.6c2.879 0 5.297 2.417 5.297 5.293v10.929C35.697 19.673 38 23.469 38 27.726 38 33.938 32.933 39 26.715 39c-4.145 0-7.945-2.3-9.903-5.867h-11.4C2.418 33.133 0 30.717 0 27.726V6.788c0-2.876 2.418-5.292 5.412-5.292zm20.843 17.026c-4.722.23-8.407 3.912-8.752 8.628-.345 5.292 3.8 9.78 9.212 9.78 5.182 0 9.212-4.142 9.212-9.204 0-5.638-4.606-9.434-9.672-9.204zm3.684-1.61V8.513H2.073v19.213c0 1.84 1.497 3.336 3.34 3.336H15.89c-.346-1.266-.46-2.646-.46-3.912.345-5.867 4.95-10.469 10.824-10.699 1.266 0 2.418.115 3.684.46zM2.073 6.558h27.866c-.23-1.726-1.612-2.992-3.339-2.992h-3.455v.576c0 .575-.46 1.035-1.036 1.035-.576 0-1.036-.46-1.036-1.035v-.576h-11.4v.576c0 .575-.46 1.035-1.037 1.035-.575 0-1.036-.46-1.036-1.035v-.576H5.412c-1.727 0-3.224 1.266-3.34 2.992z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#gradient)",
  fillRule: "nonzero",
  transform: "translate(-44 -266) translate(20 232) translate(24 33.195) translate(0 .805) translate(0 .833) translate(13 .167)",
  d: "M27.752 21.628L27.752 26.69 32.818 26.69 32.818 28.761 27.752 28.761 27.752 33.823 25.679 33.823 25.679 28.761 20.612 28.761 20.612 26.69 25.679 26.69 25.679 21.628z"
});
var _ref5 = /*#__PURE__*/React.createElement("rect", {
  transform: "translate(-44 -266) translate(20 232) translate(24 33.195) translate(0 .805) translate(0 .833) translate(13 .167)",
  width: 3.852,
  height: 3.849,
  x: 4.836,
  y: 11.619,
  fill: "url(#gradient)",
  rx: 1.924
});
var _ref6 = /*#__PURE__*/React.createElement("rect", {
  transform: "translate(-44 -266) translate(20 232) translate(24 33.195) translate(0 .805) translate(0 .833) translate(13 .167)",
  width: 3.852,
  height: 3.849,
  x: 12.552,
  y: 11.619,
  fill: "url(#gradient)",
  rx: 1.924
});
var _ref7 = /*#__PURE__*/React.createElement("rect", {
  transform: "translate(-44 -266) translate(20 232) translate(24 33.195) translate(0 .805) translate(0 .833) translate(13 .167)",
  width: 3.852,
  height: 3.849,
  x: 4.836,
  y: 18.752,
  fill: "url(#gradient)",
  rx: 1.924
});
const SvgIconHomepageMemberblockAdvocacy = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 51,
  height: 48,
  viewBox: "0 0 51 48",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconHomepageMemberblockAdvocacy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-homepage-memberblock-advocacy.62ce4d17.svg";
export { ForwardRef as ReactComponent };